import { Route } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { NotFoundComponent } from './page/not-found/not-found.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'subscription',
        loadChildren: () =>
          import('./page/subscription/routes').then(m => m.subscriptionRoutes),
      },
      {
        path: '',
        redirectTo: 'subscription',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
